import { Modal, Typography } from 'antd'
import { format } from 'date-fns'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSignedDocs } from '../../actions/document'
import EndDate from './EndDate'
const { Title } = Typography

const DocumentDeleteModal = ({document, onOk, ...props}) => {
  const dispatch = useDispatch()
  const signedDocs = useSelector(state => state.data.signedDocs)

  useEffect(() => {
    if (document) {
      dispatch(getSignedDocs(document._id))
    }
  }, [dispatch, document])

  if (!document) {
    return null
  }

  return (
    <Modal
      title={`Delete document: ${document.name || ''}`}
      okText="Delete"
      okType='danger'
      onOk={() => onOk()}
      {...props}
    >
      <Title level={5}>Are you sure you want to delete this document?</Title>
      <p>Created date: {format(new Date(document.uploaded), 'MMMM do, yyyy H:mm')}</p>
      <p>End date: <EndDate date={document.endDate} /></p>
      <p>Signers: {signedDocs ? signedDocs.length : 0}</p>
    </Modal>
  )
}

export default DocumentDeleteModal